import { StaticInfoAction } from "./action";
import { StaticInfoState, staticInfoState } from "./state";

export function StaticInfoReducer(
    state: StaticInfoState = staticInfoState,
    action: StaticInfoAction
): StaticInfoState {
    switch (action.type) {
        case "@@StaticInfoState/initBinListAction":
            return {
                ...state,
                originalList: action.binList,
                changingList: action.binList,
                enquiryType:action.enquiryType,
                districtList:action.districtList
            };

        case '@@StaticInfoState/ChangeBinListAction':
            return {
                ...state,
                changingList: action.binList
            }

        case '@@StaticInfoState/InitBinListAction':
            return {
                ...state,
                originalList: action.binList,
                changingList: action.binList,
            }

        case '@@StaticInfoState/InitBinGroupListAction':
            return {
                ...state,
                binGroupList: action.binGroupList,
            }

        case '@@StaticInfoState/InitCleanerListAction':
            return {
                ...state,
                cleanerList:action.cleanerList
            }
        case '@@StaticInfoState/InitContractListAction':
            return {
                ...state,
                contractList:action.contractList
            }
        case '@@StaticInfoState/InitDistrictListAction':
            return {
                ...state,
                districtList:action.districtList
            }
        
            case '@@StaticInfoState/InitBinTypeListAction':
                return {
                    ...state,
                    binTypeList:action.binTypeList
                }

        case '@@StaticInfoState/initContainerListAction':
            return {
                ...state,
                containerList:action.containerList
            }

        case '@@StaticInfoState/initReyclableListAction':
            return {
                ...state,
                recylcableList:action.recylcableList
            }

        case '@@StaticInfoState/initDepotListAction':
            return {
                ...state,
                depotList:action.depotList
            }

        case '@@StaticInfoState/initZoneListAction':
            return {
                ...state,
                zoneList:action.zoneList
            }

        case '@@StaticInfoState/changeFilteredZoneList':
            return {
                ...state,
                filteredZoneList:action.filteredZoneList
                
            }
        default:
            return state;
    }
}
